import MuxPlayer from '@mux/mux-player-react';

function MuxVideoPlayerBackground({
  playbackId,
  altText,
  placeholder,
}: {
  playbackId: string;
  altText?: string;
  placeholder?: string;
}) {
  return (
    <MuxPlayer
      streamType="on-demand"
      playbackId={playbackId}
      autoPlay
      placeholder={placeholder}
      nohotkeys
      minResolution="720p"
      maxResolution="1080p"
      muted
      loop
      metadata={{
        video_id: playbackId,
        video_title: altText || 'Video',
      }}
      style={{ '--controls': 'none', '--media-object-fit': 'cover' }}
      className="h-full w-full"
    />
  );
}

function MuxVideoPlayer({
  playbackId,
  altText,
  placeholder,
}: {
  playbackId: string;
  altText?: string;
  placeholder?: string;
}) {
  return (
    <MuxPlayer
      streamType="on-demand"
      playbackId={playbackId}
      autoPlay={false}
      placeholder={placeholder}
      minResolution="720p"
      maxResolution="1080p"
      muted
      metadata={{
        video_id: playbackId,
        video_title: altText || 'Video',
      }}
      className="h-full w-full"
      accentColor="var(--color-orange)"
    />
  );
}

export function Video({
  playbackId,
  isBackgroundVideo = false,
  altText,
  placeholder,
  aspectRatio,
}: {
  playbackId: string;
  isBackgroundVideo?: boolean;
  altText?: string;
  placeholder?: string;
  aspectRatio?: number;
}) {
  return (
    <div
      className="mx-auto w-full"
      style={aspectRatio && !isBackgroundVideo ? { aspectRatio } : undefined}
    >
      {isBackgroundVideo ? (
        <MuxVideoPlayerBackground
          playbackId={playbackId}
          placeholder={placeholder}
        />
      ) : (
        <MuxVideoPlayer
          playbackId={playbackId}
          altText={altText}
          placeholder={placeholder}
        />
      )}
    </div>
  );
}
